import React,{Component} from "react";
import InformazioniSulCaso from "./InformazioniSulCaso";
import QuadroClinicoEsordio from "./QuadroClinicoEsordio";
import Anamnesi from "./Anamnesi";
import Complicanze from "./Complicanze";
import FattoriRischio from "./FattoriRischio";
import AltriFattori from "./AltriFattori";
import Note from "./Note";
import DatiDiLaboratorio from "./DatiDiLaboratorio";
import Utils from "../../../../../../utils/Utils";

export default class SchedaSpecialeEpatiteE extends Component {

    state={
        schedaSpecialeEpatiteE: {
            informazioniSulCaso: {},
            quadroClinicoEsordio: {},
            anamnesi: {},
            complicanze: {},
            fattoriRischio: {},
            altriFattori:{},
            datiDiLaboratorio:{},
            note:{},
        },
        validate:{
            informazioniSulCaso:{},
            quadroClinicoEsordio:{},
            complicanze:{},
            altriFattori:{},
            datiDiLaboratorio:{}

        },
        objectForBackend: {},
        corretto:[]
    }

    componentDidMount() {
        this.props.setSchedaSpecialeECorretto(this.state.schedaSpecialeEpatiteE, "", this.state.corretto);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState!==this.state){
            
            let objFinal = this.createJsonForBackend()
            this.props.setSchedaSpecialeECorretto(objFinal, this.validate(), this.state.corretto);
        }

    }

    validate() {
        let validate = this.state.validate

        for (let key in validate) {
            if (validate[key]) {
                return validate[key]
            }
        }

        return ""
    }

    createJsonForBackend() {
        let ObjectForBackEnd = {}
        ObjectForBackEnd = Object.assign({}, Utils.removeFieldFromObject(this.state.objectForBackend, "corretto"))
        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res;

    }

    constructor(props) {
        super(props);
        this.setStatePadre=this.setStatePadre.bind(this);
        this.controlloDati=this.controlloDati.bind(this);
        this.createJsonForBackend = this.createJsonForBackend.bind(this);
        this.validate=this.validate.bind(this);
    }

    setStatePadre(object, nomeAttributo, objectForBackend, validate){
        let schedaSpecialeEpatiteE=this.state.schedaSpecialeEpatiteE;
        let newObjectForBackend = this.state.objectForBackend;
        let newValidate=this.state.validate;
        newValidate[nomeAttributo]=validate;
        schedaSpecialeEpatiteE[nomeAttributo]=object;
        newObjectForBackend[nomeAttributo] = objectForBackend
        this.setState({schedaSpecialeEpatiteE:schedaSpecialeEpatiteE, objectForBackend: newObjectForBackend, validate: newValidate});
        this.controlloDati();
    }

    controlloDati(){
        let schedaSpecialeEpatiteE=this.state.schedaSpecialeEpatiteE;
        let textList=[];

        if (schedaSpecialeEpatiteE.informazioniSulCaso.corretto && schedaSpecialeEpatiteE.informazioniSulCaso.corretto.length>0 ){
            textList=textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatiteE.informazioniSulCaso.corretto))
        }
        if (schedaSpecialeEpatiteE.quadroClinicoEsordio.corretto && schedaSpecialeEpatiteE.quadroClinicoEsordio.corretto.length>0 ){
            textList=textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatiteE.quadroClinicoEsordio.corretto))
        }
        if (schedaSpecialeEpatiteE.anamnesi.corretto && schedaSpecialeEpatiteE.anamnesi.corretto.length>0 ){
            textList=textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatiteE.anamnesi.corretto))
        }
        if (schedaSpecialeEpatiteE.complicanze.corretto && schedaSpecialeEpatiteE.complicanze.corretto.length>0 ){
            textList=textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatiteE.complicanze.corretto))
        }
        if (schedaSpecialeEpatiteE && schedaSpecialeEpatiteE.altriFattori && schedaSpecialeEpatiteE.altriFattori.corretto && schedaSpecialeEpatiteE.altriFattori.corretto.length>0 ){
            textList=textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatiteE.altriFattori.corretto))
        }
        if (schedaSpecialeEpatiteE.datiDiLaboratorio.corretto && schedaSpecialeEpatiteE.datiDiLaboratorio.corretto.length>0 ){
            textList=textList.concat(Utils.eliminaNullArray(schedaSpecialeEpatiteE.datiDiLaboratorio.corretto))
        }
        this.setState({corretto:textList});

    }

    render(){
        return(
            <div>
                <InformazioniSulCaso
                    setStatePadre={this.setStatePadre}
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    datiPaziente={this.props.datiPaziente}
                />
                <QuadroClinicoEsordio
                    setStatePadre={this.setStatePadre}
                    informazioniSulCaso={this.state.schedaSpecialeEpatiteE && this.state.schedaSpecialeEpatiteE.informazioniSulCaso && !Utils.isEmpty(this.state.schedaSpecialeEpatiteE.informazioniSulCaso) ? this.state.schedaSpecialeEpatiteE.informazioniSulCaso : this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.informazioniSulCaso ? this.props.segnalazioneCopia.schedaSpeciale.informazioniSulCaso : "" }
                    annoTrapianto={this.state.schedaSpecialeEpatiteE && !Utils.isEmpty(this.state.schedaSpecialeEpatiteE.anamnesi) && this.state.schedaSpecialeEpatiteE.anamnesi.annoTrapianto ? this.state.schedaSpecialeEpatiteE.anamnesi.annoTrapianto :  this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.anamnesi && this.props.segnalazioneCopia.schedaSpeciale.anamnesi.annoTrapianto ? this.props.segnalazioneCopia.schedaSpeciale.anamnesi.annoTrapianto : ""}
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    dataInizio={this.state.schedaSpecialeEpatiteE && !Utils.isEmpty(this.state.schedaSpecialeEpatiteE.altriFattori) && this.state.schedaSpecialeEpatiteE.altriFattori.dataInizio ? this.state.schedaSpecialeEpatiteE.altriFattori.dataInizio :  this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.altriFattori && this.props.segnalazioneCopia.schedaSpeciale.altriFattori.dataInizio ? this.props.segnalazioneCopia.schedaSpeciale.altriFattori.dataInizio : ""}
                    dataDecesso={this.state.schedaSpecialeEpatiteE && !Utils.isEmpty(this.state.schedaSpecialeEpatiteE.complicanze) && this.state.schedaSpecialeEpatiteE.complicanze.dataDecesso ? this.state.schedaSpecialeEpatiteE.complicanze.dataDecesso :  this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.complicanze && this.props.segnalazioneCopia.schedaSpeciale.complicanze.dataDecesso ? this.props.segnalazioneCopia.schedaSpeciale.complicanze.dataDecesso : ""}
                />
                <Anamnesi
                    setStatePadre={this.setStatePadre}
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    sesso={this.state.schedaSpecialeEpatiteE.informazioniSulCaso && this.state.schedaSpecialeEpatiteE.informazioniSulCaso.sesso ? this.state.schedaSpecialeEpatiteE.informazioniSulCaso.sesso : this.props.datiPaziente.sesso}
                />
                <Complicanze
                    setStatePadre={this.setStatePadre}
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                />
                <FattoriRischio
                    setStatePadre={this.setStatePadre}
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                />
                <AltriFattori
                    setStatePadre={this.setStatePadre}
                    dataSintomi={this.state.schedaSpecialeEpatiteE && !Utils.isEmpty(this.state.schedaSpecialeEpatiteE.quadroClinicoEsordio) && this.state.schedaSpecialeEpatiteE.quadroClinicoEsordio.dataSintomi ? this.state.schedaSpecialeEpatiteE.quadroClinicoEsordio.dataSintomi :  this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.quadroClinicoEsordio && this.props.segnalazioneCopia.schedaSpeciale.quadroClinicoEsordio.dataSintomi ? this.props.segnalazioneCopia.schedaSpeciale.quadroClinicoEsordio.dataSintomi : ""}
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                />
                <DatiDiLaboratorio
                    setStatePadre={this.setStatePadre}
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    dataDecesso={this.state.schedaSpecialeEpatiteE && !Utils.isEmpty(this.state.schedaSpecialeEpatiteE.complicanze) && this.state.schedaSpecialeEpatiteE.complicanze.dataDecesso ? this.state.schedaSpecialeEpatiteE.complicanze.dataDecesso :  this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.complicanze && this.props.segnalazioneCopia.schedaSpeciale.complicanze.dataDecesso ? this.props.segnalazioneCopia.schedaSpeciale.complicanze.dataDecesso : ""}
                    dataSintomi={this.state.schedaSpecialeEpatiteE && !Utils.isEmpty(this.state.schedaSpecialeEpatiteE.quadroClinicoEsordio) && this.state.schedaSpecialeEpatiteE.quadroClinicoEsordio.dataSintomi ? this.state.schedaSpecialeEpatiteE.quadroClinicoEsordio.dataSintomi :  this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.quadroClinicoEsordio && this.props.segnalazioneCopia.schedaSpeciale.quadroClinicoEsordio.dataSintomi ? this.props.segnalazioneCopia.schedaSpeciale.quadroClinicoEsordio.dataSintomi : ""}
                />
                <Note
                    setStatePadre={this.setStatePadre}
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                />
            </div>
        )
    }
}

